import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DocumentType } from '../../enums';
import {
  getDocumentName,
  getDocumentType,
  processDocumentImage,
} from '../../utils/document-processing.utility';

@Component({
  selector: 'kt-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss'],
})
export class DocumentViewerComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  DocumentType = DocumentType;
  isDialog = false;
  loading$ = new BehaviorSubject(false);
  pages = [];
  count = 0;
  pageIdx = 0;
  zoomScale = 1;
  type: DocumentType;
  @Input() path: string;
  @Input() url: string;
  @Input() base64: string;

  constructor(
    private dialogRef: MatDialogRef<DocumentViewerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: Partial<{ isDialog: boolean; path: string; url: string; base64: string }>,
  ) {}

  ngOnInit(): void {
    this.isDialog = !!this.data?.isDialog;

    this.path = this.isDialog ? this.data.path : this.path;
    this.url = this.isDialog ? this.data.url : this.url;
    this.base64 = this.isDialog ? this.data.base64 : this.base64;

    this.type = getDocumentType(this.base64 || this.path);

    if (this.base64) {
      if (this.type === DocumentType.IMG) {
        this.pages = [this.base64];
        this.count = 1;
      } else if (this.type === DocumentType.PDF) {
        this.url = this.base64;
      }
    } else if (this.type === DocumentType.IMG) {
      this.loading$.next(true);
      this.subscriptions.add(
        processDocumentImage(this.path, this.url)
          .pipe(
            catchError(() => {
              this.loading$.next(false);

              return of([]);
            }),
          )
          .subscribe((pages) => {
            this.pages = pages;
            this.count = pages?.length;
            this.loading$.next(false);
          }),
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getDocumentName(): string {
    return getDocumentName(this.path);
  }

  togglePage(order: 'PREV' | 'NEXT'): void {
    switch (order) {
      case 'PREV':
        this.pageIdx = this.pageIdx > 0 ? this.pageIdx - 1 : this.pageIdx;
        break;
      case 'NEXT':
        this.pageIdx = this.pageIdx < this.count - 1 ? this.pageIdx + 1 : this.pageIdx;
        break;
    }
  }

  zoom(type: 'IN' | 'FIT' | 'OUT'): void {
    switch (type) {
      case 'IN':
        this.zoomScale = this.zoomScale * 1.1;
        break;
      case 'FIT':
        this.zoomScale = 1;
        break;
      case 'OUT':
        this.zoomScale = this.zoomScale * 0.9;
        break;
    }
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
